let doprint = false;

export const syncHeight = () => {
    document.documentElement.style.setProperty(
        '--window-inner-height',
        `${window.innerHeight}px`
    );
  }

  export const triggerBlobDownload = (blob, fileName) => {
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.innerText = "Download ZIP";
    downloadLink.style.float = 'right';
    downloadLink.style.display = "none";
    downloadLink.setAttribute("download", fileName); // name file
    document.getElementById("root").appendChild(downloadLink);
    downloadLink.click();
    document.getElementById("root").removeChild(downloadLink);
  }


  export const extraStemTitleProcessor = (numberedStems, title, otherTracksInSong) => {

	if (doprint) console.log("pgw extraStemTitleProcessor numberedStems = ", numberedStems);
	if (doprint) console.log("pgw extraStemTitleProcessor title = ", title);
	if (doprint) console.log("pgw extraStemTitleProcessor otherTracksInSong = ", otherTracksInSong);


    let allStemNames = "";
	let longest_common_substring = ""

	let lcss = longest_common_starting_substring(allStemNames)
	if (doprint) console.log("pgw extraStemTitleProcessor lcss = ", lcss);
	if (doprint) console.log("pgw extraStemTitleProcessor title 1 = ", title);

	let lces = longest_common_ending_substring(allStemNames)
	if (doprint) console.log("pgw extraStemTitleProcessor lces = ", lces);
	if (doprint) console.log("pgw extraStemTitleProcessor title 1 = ", title);


	if (numberedStems) {
		allStemNames = otherTracksInSong.map(track => track.name.substring(1));
		longest_common_substring = longest_common_ending_substring(allStemNames)
	}
	else {
		allStemNames = otherTracksInSong.map(track => track.name);
		longest_common_substring = longest_common_starting_substring(allStemNames)
	}
	if (doprint) console.log("pgw extraStemTitleProcessor allStemNames = ", allStemNames);
	if (doprint) console.log("pgw extraStemTitleProcessor longest_common_substring = ", longest_common_substring);

    // remove common labelling
    // title = title.replace(longest_common_starting_substring(allStemNames), '');
    title = title.replace(longest_common_substring, '');

	if (doprint) console.log("pgw extraStemTitleProcessor title 2 = ", title);


    // remove bracketed numbers - should be a regex really but there are only (1) and (2) in the json currently. Easier.
    title =  title.replace('(1)','').replace('(2)', '');

    // replace underscores with spaces
    title =  title.replace('_', ' ');
    
    // convert to uppercase
    title = title.toUpperCase();

    // remove the words empty - regardless of where it positioned, we dont want it.
    title =  title.replace('EMPTY', '');

    // trim any remaining space from either end
    title = title.trim();

	if (doprint) console.log("pgw extraStemTitleProcessor title 3 = ", title);


    return title;
  };

  export const longest_common_starting_substring = (arr1) => {

	if (doprint) console.log("pgw longest_common_starting_substring arr1 = ", arr1);
	if (doprint) console.log("pgw longest_common_starting_substring arr1.concat().sort = ", arr1.concat().sort);

	if (arr1.concat().sort == null) {
		return ""
	}
    const arr= arr1.concat().sort();
    const a1= arr[0];
    const a2= arr[arr.length-1];
    const L= a1.length;
    let i= 0;
    while(i< L && a1.charAt(i)=== a2.charAt(i)) i++;
    return a1.substring(0, i);
  }


  export const longest_common_ending_substring = (arr1) => {

	if (doprint) console.log("pgw longest_common_ending_substring arr1 = ", arr1);
	if (doprint) console.log("pgw longest_common_ending_substring arr1.concat().sort = ", arr1.concat().sort);

	if (arr1.concat().sort == null) {
		return ""
	}

	const arr = arr1.concat().sort();
	const a1 = arr[0];
	const a2 = arr[arr.length - 1];
	const L1 = a1.length;
	const L2 = a2.length;
	let i = 0;

	while (
	  i < L1 &&
	  i < L2 &&
	  a1.charAt(L1 - 1 - i) === a2.charAt(L2 - 1 - i)
	) {
	  i++;
	}

	return a1.substring(L1 - i);
  };



